import React from "react";
import { useState, useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import Stepper from "react-stepper-horizontal";
import "../../scss/dashboard/crearplantilla.css";

import HookForm from "./formas/formAbogados";
import DatosPago from "./formas/datosPago";
import PlantillasConfig from "./formas/plantillasConfig";
import UploadPdf from "./formas/dragDocument";

import { PublicTemplateForm } from "./PublicTemplateForm";
import { useRequestCustomTemplate } from "../../api/hooks/templates";

function CrearPlantillas() {
  const [step, setStep] = useState(0);
  const history = useHistory();

  const methods = useForm({ mode: "all" });
  const { mutate: mutateRequestTemplate, isLoading } = useRequestCustomTemplate(
    {
      onSuccess: ({ data }) => {
        history.push("/lawyers/templates/in-review");
      },
    }
  );

  const handleNextStep = () => {
    setStep(step + 1);
  };
  const handleSave = (data = {}) => {
    mutateRequestTemplate({ ...data, type: "lawyers" });
  };

  return (
    <div className="abogados__crearPlantilla">
      <div className="abogados__crearPlantilla--h3">
        <h3 className="font-weight-bold">Crear Plantilla</h3>
      </div>
      <FormProvider {...methods}>
        <div className="abogados__crearPlantilla--container">
          <div className="abogados__crearPlantilla--stepper">
            <Stepper
              steps={[
                { title: "Datos Basicos" },
                { title: "Configuración Plantilla" },
                // { title: "Datos Pago" },
                { title: "Subir Documento" },
              ]}
              fontFamily="Roboto"
              completeColor={"#f37b33"}
              activeColor={"#707171"}
              defaultColor={"#f37b33"}
              activeStep={step}
              circleTop={30}
              titleTop={8}
            />
          </div>

          <div className="Plantilla--container--form">
            <section className="plantillasConfig">
              {/* {getStepContent(step, compiledForm)} */}
              <PublicTemplateForm
                currentStep={step}
                isRequestingTemplate={isLoading}
                onNextStep={handleNextStep}
                onSave={handleSave}
              />
            </section>
          </div>
        </div>
      </FormProvider>
    </div>
  );
}

export default CrearPlantillas;
